import { Component, HostListener } from '@angular/core';
import { CommonService } from './service/common.service';
import { UsersService } from './service/users.service';
import { ActivatedRoute, Router , NavigationStart, NavigationEnd, Event as NavigationEvent} from '@angular/router';
import { Role } from './app.constant';

declare var $;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title: string = 'wellnessSupportTools';
//  redirectUrl:string="";
  menu_flg:boolean = false;//メニューバーを表示する
  signout_flg : boolean = false;//サインアウトボタンを表示する

  ROLE: any = Role;

  eid:string = '0';
  qcid:string = '0';
  qid:string = '0';
  lid:string = '0';
  ro :string = '0';

  yhid :string = '0';
  tid: string = '0';
  did :string = '0';

  ssoFlg:boolean = false;
  ssoKwansei: boolean = false;
  
  constructor(
    public commonService: CommonService,
    public usersService: UsersService,
    public router: Router,
    private route: ActivatedRoute,
  ) {

    /*  Route event types
            NavigationStart
            NavigationEnd
            NavigationCancel
            NavigationError
            RoutesRecognized
        */
       router.events.forEach((event: NavigationEvent) => {
        //画面上部へ移動
        window.scrollTo(0, 0);
        
        //Before Navigation
        if (event instanceof NavigationStart) {
//          console.log("NavigationStart:"+event.url);
          if ((event.url=="/signin") || (event.url.substring(0,7)=="/signin") || (event.url == "/")){
            this.menu_flg = false;
            this.signout_flg = false;
          }else if(event.url=='/fpassword'){
            this.menu_flg = false;
            this.signout_flg = true;
          }else{
            this.menu_flg = true;
            this.signout_flg = true;
            var checkParamList=event.url.split("/");
            switch (checkParamList[1]){
              case "question-register"://→問診票がアクティブタブ
              //:qcid/:qid/:lid/:ro
                this.eid = '0';
                this.qcid = checkParamList[2];
                this.qid = checkParamList[3];
                this.lid = checkParamList[4];
                this.ro  = checkParamList[5];
                return
                          
              case "question-list"://→問診票がアクティブタブ
              case "result-analysis":
              //:qcid/:lid
                this.eid = '0';
                this.qcid = checkParamList[2];
                this.qid = '0';
                this.lid = checkParamList[3];
                this.ro  = '0';
                return
            
              case "question-category"://→イベントがアクティブタブ
              case "mail":
              case "progress":
              case "person":
              case "maintenance":
                this.eid = checkParamList[2];
                this.qcid = '0';
                this.qid = '0';
                this.lid = '0';
                this.ro  = '0';
                return

              case "m"://→イベントがアクティブタブ
                this.eid = checkParamList[3];
                this.qcid = '0';
                this.qid = '0';
                this.lid = '0';
                this.ro  = '0';
                return

              case "yoyaku-hyo"://→予約表がアクティブタブ
                this.eid = checkParamList[2];
                this.yhid = '0';
                this.did = '0';
                this.tid = '0';
              return

              case "yoyaku-list"://→予約表がアクティブタブ
              case "yoyaku-register"://→予約表がアクティブタブ
                this.eid = '0';
                this.yhid = checkParamList[2];
                this.did = '0';
                this.tid = '0';
              return

              case "y"://→予約表がアクティブタブ
                this.eid = '0';
                this.yhid = '0';
                this.did = checkParamList[3];
                this.tid = checkParamList[3];
              return
                          
  
              default:
                this.eid = '0';
                this.qcid ='0';
                this.qid = '0';
                this.lid = '0';
                this.ro  = '0';
                return
            }
          }
        }

        //After Navigation
        if (event instanceof NavigationEnd) {
//          console.log("NavigationEnd:"+event.url);


        }
    });
   }
   ngOnInit(): void {
      var page_url = location.href;
      this.ssoFlg = page_url .includes("wellnessSupportToolsSec");
      // this.ssoKwansei = page_url.includes("https://abr-net.com//");
      // var match = page_url .includes("localhost");
      //Loading停止
      this.commonService.loadingEnd();
  };
  
  onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
  }

  signout() {
    this.commonService.modalOpens(59001,
      //ログアウトしますか？
      modalresult => {
        if (modalresult == "OK") {
          this.usersService.signout()
            .subscribe();
          this.usersService.clearUserInfo();
          if(this.ssoFlg){
            // サインアウトはシボレスのサインアウト画面へ
            this.usersService.getServerConnection()
            .subscribe((res: Response) => {
              location.href = 'https://abr-net.com/wellnessSupportToolsSec/';
            },error => {
              this.commonService.modalOpens(error,modalresult=>{});
            });
          }else{
            this.router.navigate(["/signin"]);
          }
        } else {
          
        }
      }
    );
  }

  selectP(p: string): void {
    $('html,body').animate(
      { scrollTop: $(`#${p}`).offset().top - 55 }
    );
  }

  //処理が重くなる原因なのでコメントアウト
  
  // @HostListener('window:scroll', ['$event'])
  // onScroll(event) {
  //   let timer = null;
    
  //   //スクロールが100に達したらボタン表示
  //   $(window).scroll(function () {
  //     clearTimeout( timer );
  //     timer = setTimeout(function() {
  //       //html(CSS)側で非表示にしているボタンをスクロールイベントで制御
  //       let topBtn = $('#page-top');
  //       if ($(this).scrollTop() > 100) {
  //         topBtn.fadeIn();
  //       } else {
  //         topBtn.fadeOut();
  //       }
  //     }, 200 );
      
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts